"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SendMessageButton = require("./SendMessageButton");
Object.keys(_SendMessageButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SendMessageButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SendMessageButton[key];
    }
  });
});